module.exports = __webpack_public_path__ + "img/loading.30b0aeed.gif";